import {
    REQUEST_ACCOUNT_MESSAGES,
    RECEIVE_ACCOUNT_MESSAGES,
    FAILURE_ACCOUNT_MESSAGES
} from './constants';
import { CALL_API } from '../../../middlewares/api';
import _ from 'lodash';

const shouldFetchAccountMessages = state => {
    const messages = state.account.mymessages.messages;
    const fetching = state.account.mymessages.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(messages)) {
        return true;
    } else {
        return false;
    }
};

export function fetchAccountMessagesIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/service-client',
            types: [REQUEST_ACCOUNT_MESSAGES, RECEIVE_ACCOUNT_MESSAGES, FAILURE_ACCOUNT_MESSAGES],
            shouldCallAPI: state => shouldFetchAccountMessages(state),
            authenticated: true
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/mymessages/actions.js